import { QueryParameterSchema } from './types';

export const campusIdFilterQueryFilter: QueryParameterSchema<'campusId'> = {
  getDefaultValue: () => [],
  getValue: ({ queryParameters }) => queryParameters.campusId,

  fromUrlSearchParams: ({ urlSearchParams }) => ({
    campusId: (urlSearchParams.get('filter[campusId]') || '').split(','),
  }),
  toUrlSearchParams: ({ value }) => ({ 'filter[campusId]': value.join(',') }),
  toSearchQuery: ({ value }) => {
    if (value.length === 0) return {};
    return { 'filter[campusId]': value };
  },
  sanitize: ({ value, staticProps }) => {
    const {
      referenceData: { campuses },
    } = staticProps;
    return { campusId: value.filter((s) => !!s && !!(campuses ?? {})[s]) };
  },
  getSummaryItems: ({
    value,
    staticProps: {
      referenceData: { campuses },
    },
  }) => {
    return value.map((campusId) => ({
      filterKey: 'campusId',
      key: campusId,
      label: `${(campuses ?? {})[campusId]?.name}`,
      value: campusId,
    }));
  },
  removeParam: ({ value, removedValue }) => {
    return { campusId: value.filter((item) => item !== removedValue) };
  },
};
